/* Geist (2026-10) – az XBoost-kosár kiváltása: ajándék automatikus kezelése a téma saját becsúszó kosarában.
   A „jogosult” összeget a kosár Liquid-kódja számolja (snippets/v8-cart-rewards.liquid → data-v8-*),
   mert csak az kollekció-pontos. Ha eléri a küszöböt, az ajándék (Felülettisztító) bekerül a kosárba
   _v8gift tulajdonsággal; ha a kosár a küszöb alá esik, kikerül. A kedvezményt a Shopify „Ajándék termék”
   automatikus kedvezménye adja. */
(function () {
  var busy = false, again = false;
  var SECTIONS = 'cart-drawer,cart-icon-bubble';

  function parse(html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); }

  function render(s) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && s['cart-drawer']) {
      var inner = parse(s['cart-drawer'], '#CartDrawer');
      var target = document.getElementById('CartDrawer');
      if (inner && target) target.innerHTML = inner.innerHTML;
      var ov = document.getElementById('CartDrawer-Overlay');
      if (ov) ov.addEventListener('click', function () { drawer.close(); });
      var empty = !!(inner && inner.querySelector('.drawer__inner-empty'));
      drawer.classList.toggle('is-empty', empty);
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && s['cart-icon-bubble']) {
      var b = parse(s['cart-icon-bubble'], '.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }
  }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }

  async function sync() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      var res = await fetch(window.location.pathname + '?sections=' + SECTIONS);
      var s = await res.json();
      var el = parse(s['cart-drawer'] || '', '[data-v8-elig]');
      var changed = false;
      if (el) {
        var elig = +el.dataset.v8Elig, t2 = +el.dataset.v8T2, gift = +el.dataset.v8Gift;
        var key = el.dataset.v8GiftKey, qty = +el.dataset.v8GiftQty || 0;
        if (elig >= t2 && !key) {
          await post('/cart/add.js', { items: [{ id: gift, quantity: 1, properties: { _v8gift: '1' } }] }); changed = true;
        } else if (elig < t2 && key) {
          await post('/cart/change.js', { id: key, quantity: 0 }); changed = true;
        } else if (key && qty > 1) {
          await post('/cart/change.js', { id: key, quantity: 1 }); changed = true;
        }
      }
      /* SZETT5 (−5% a teljes szettre): csak addig marad, amíg a „Mindet kérem” szett minden tétele a kosárban van */
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      var hasSet = codes.some(function (c) { return String(c).toUpperCase() === 'SZETT5'; });
      if (hasSet) {
        var setIds = String((cart.attributes || {})._v8set || '').split(',').filter(Boolean).map(Number);
        var inCart = cart.items.map(function (i) { return i.variant_id; });
        var intact = setIds.length >= 3 && setIds.every(function (id) { return inCart.indexOf(id) > -1; });
        if (!intact) {
          await post('/cart/update.js', { discount: codes.filter(function (c) { return String(c).toUpperCase() !== 'SZETT5'; }).join(','), attributes: { _v8set: '' } });
          changed = true;
        }
      }
      if (changed) {
        if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        res = await fetch(window.location.pathname + '?sections=' + SECTIONS);
        s = await res.json();
      }
      if (changed) render(s);
    } catch (e) { /* csendes hiba: a kosár enélkül is működik */ }
    busy = false;
    if (again) { again = false; sync(); }
  }

  function hook() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
        if (ev && ev.source === 'v8-cart') return;
        setTimeout(sync, 60);
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hook); else hook();
  window.v8CartSync = sync;
})();
